import { FC } from "react";

import dynamic from "next/dynamic";

import { UserConsentFormProps } from "./types";

export type { UserConsentFormProps } from "./types";

// Disabled SSR to avoid memory leak caused by makeStyles
export const UserConsentForm = dynamic(() => import("./UserConsentFormSsr").then((mod) => mod.UserConsentFormSsr), {
  ssr: false,
}) as FC<UserConsentFormProps>;
